module.exports = __webpack_public_path__ + "static/rompecabezas-679dfa3b0c1734494a677e5aa619da23.png";